/* eslint-disable import/prefer-default-export */
export const UPDATE_BUTTON_STATES = '@@rex/button/update';



// WEBPACK FOOTER //
// ./src/redux/types.js